import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable } from 'rxjs';
import { buildHttpParams } from '../utils';
import { PaginatedResponse } from '../common/models/common.model';
import { AttendanceLog } from './attendance.model';

@Injectable({
  providedIn: 'root',
})
export class AttendanceService {
  private _baseUrl: string = 'attendance/admin/';

  constructor(private _apiService: ApiService) {}

  list(): Observable<any> {
    return this._apiService.get(this._baseUrl + 'users/');
  }

  today_attendance(params = {}): Observable<any> {
    const q = buildHttpParams(params);
    return this._apiService.get(this._baseUrl + 'today/', q);
  }

  public employee_attendance(id: string, q = {}): Observable<any> {
    const params = buildHttpParams(q);
    return this._apiService.get(this._baseUrl + 'users/' + id, params);
  }

  public downloadReport(data: { start_date: string; end_date: string }): Observable<any> {
    return this._apiService.post(this._baseUrl + 'report/', data);
  }

  public getAttendanceLogs(
    employeeId: string,
    query: Record<string, any> = {}
  ): Observable<PaginatedResponse<AttendanceLog>> {
    const params = buildHttpParams({ ...query, employee_id: employeeId });
    return this._apiService.get(this._baseUrl + 'attendance-logs/', params);
  }

  public downloadAttendanceLogs(payload: {
    employee_id: string;
    start_date: string;
    end_date: string;
  }): Observable<{ report_url: string; message?: string }> {
    return this._apiService.post(this._baseUrl + 'attendance-logs/report/', payload);
  }

  public exportAttendanceLogReport(payload: {
    employee_id?: string;
    year?: number;
    month?: number;
    start_date?: string;
    end_date?: string;
  }): Observable<Blob> {
    return this._apiService.postBlob(this._baseUrl + 'attendance-logs/report/', payload);
  }
}
